var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoPricing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.32843 20H20C21.11 20 22 19.11 22 18V6C22 5.52925 21.8399 5.09806 21.5709 4.75755L19.8514 6.47704C19.9456 6.62945 20.0001 6.8087 20.0001 7.00006V17.0001C20.0001 17.5501 19.5501 18.0001 19.0001 18.0001H8.32837L6.32843 20Z",
    fill: "#6B7684"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.90566 16.4228C9.80612 16.6344 9.63446 16.806 9.42287 16.9056L9.90566 16.4228Z",
    fill: "#6B7684"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3285 15.9999H11C11.55 15.9999 12 15.5499 12 14.9999V14.3284L10.3285 15.9999Z",
    fill: "#6B7684"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 12.9142L8.25219 16.662C8.09548 16.4853 8.00003 16.2532 8.00003 15.9999H7.00003C6.63946 15.9999 6.32187 15.8065 6.14588 15.5183L7.66428 13.9999H10V12.9999H8.66428L10.6643 10.9999H11C11.55 10.9999 12 11.4499 12 11.9999V12.9142Z",
    fill: "#6B7684"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3284 10H17.2571C17.4488 10 17.5652 9.82849 17.4609 9.6964L17.0968 9.23161L16.3284 10Z",
    fill: "#6B7684"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4756 8.43858L14.9142 10H14.7431C14.5514 10 14.4349 9.82849 14.5392 9.6964L15.7938 8.09167C15.8909 7.96944 16.1093 7.96944 16.2039 8.09167L16.4756 8.43858Z",
    fill: "#6B7684"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9142 6.00006L20.7646 4.14966C20.5294 4.05315 20.2712 4 20 4H17.6642L15.6642 6.00006H18.9142Z",
    fill: "#6B7684"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2499 6.00006L16.25 4H4C2.89 4 2.01 4.89 2.01 6L2 18C2 18.08 2.00463 18.1589 2.01362 18.2364L4.00006 16.2499V7.00006C4.00006 6.45006 4.45006 6.00006 5.00006 6.00006H14.2499Z",
    fill: "#6B7684"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M7.25007 12.9999L9.25007 10.9999H8.00003V9.99993H10.2501L11.8203 8.4297C11.6392 8.17038 11.3385 7.99993 11 7.99993H10V7.98993C10 7.43993 9.55003 6.98993 9.00003 6.98993C8.45003 6.98993 8.00003 7.43993 8.00003 7.98993V7.99993H7.00003C6.45003 7.99993 6.00003 8.44993 6.00003 8.99993V11.9999C6.00003 12.5499 6.45003 12.9999 7.00003 12.9999H7.25007Z",
    fill: "#6B7684"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M4.14585 17.5184C4.32183 17.8066 4.63945 18.0001 5.00006 18.0001H6.91415L4.91421 20H4C3.35886 20 2.79112 19.7031 2.42588 19.2383L4.14585 17.5184Z",
    fill: "#6B7684"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2571 14.0001H14.7431C14.5514 14.0001 14.4349 14.1716 14.5392 14.3037L15.7962 15.9085C15.8909 16.0307 16.1093 16.0307 16.2063 15.9085L17.4609 14.3037C17.5652 14.1716 17.4488 14.0001 17.2571 14.0001Z",
    fill: "#6B7684"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9142 2.75L0.414185 21.25H3.66418L22.1642 2.75H18.9142Z",
    fill: "#6B7684"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoPricing);
export default __webpack_public_path__ + "static/media/NoPricing.e9b0268e8083c3046fe65b4b9493e250.svg";
export { ForwardRef as ReactComponent };